const currentOrigin = window.location.origin;
const currentHost   = window.location.hostname;

const legacyKey    = 'open_from';
const legacyVal    = 'app';
const balancerFlag = 'open_from_app';

export function addAppFlagToLinks(scope = document) {
  if (sessionStorage.getItem('open_from_app') !== 'true') return;

  const root = scope instanceof Element || scope instanceof Document
    ? scope
    : document;

  const links = root.matches?.('a')
    ? [root]
    : root.querySelectorAll('a');

  links.forEach((link) => {
    const href = link.getAttribute('href');

    if (!href) return;

    if (
      href.startsWith('#') ||
      href.startsWith('mailto:') ||
      href.startsWith('tel:') ||
      href.startsWith('javascript:')
    ) return;

    let url;

    try {
      url = new URL(href, currentOrigin);
    } catch (e) {
      return;
    }

    if (url.hostname !== currentHost) return;

    url.searchParams.set(legacyKey, legacyVal);
    link.setAttribute('href', url.toString());
  });
}

jQuery(function () {
  let hasLegacy = false;

  try {
    hasLegacy = new URLSearchParams(window.location.search).get(legacyKey) === legacyVal;
  } catch (e) {
    hasLegacy = window.location.search.includes('open_from=app');
  }

  const hasBalancerFlag = new RegExp(`(?:\\?|&)${balancerFlag}(?:&|$)`)
    .test(window.location.search);

  if (hasLegacy || hasBalancerFlag) {
    sessionStorage.setItem('open_from_app', 'true');
  }

  addAppFlagToLinks(document.querySelector('.main-wrap'));
});